// 登录相关常量
export default {
    PUB_KEY:
        'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCbNpktS9j5qbO6EB54HIYOkJdkIuyUUwgFBGRDE0+97hZDWEhK2UkzycIAomhd16sixgAULYNGGRknWhfHOMG17TUw8ZDFo7qJRAica2VBuJWd1jZylHq4TJc0xza5ZqdnjtHaF8V8ZN7A3RwnuCaTjhJt5BRBZlbe+Lag2R6RHQIDAQAB',
    emailSliderSessionHeader: 'idaas_',
    POSTFIX_DOMAIN: typeof window !== 'undefined' ? location.hostname.substring(location.hostname.indexOf('.') + 1) : "",

    // 验证信息：本地存储的key值(Verification information: locally stored key value)
    StorageKeysMap: {
        stepCode: "RETAIL_CLOUD_LOGIN_STEP_CODE",                       // 手机号登录方式验证码，实现120s内若收到验证码可重复使用来登录(Mobile phone number login method verification code, if the verification code is received within 120s, it can be reused to log in)
        urlParamsToBind: "RETAIL_CLOUD_LOGIN_URL_PARAMS_TO_BIND_PC",     // 三方账号绑定的页面参数(Page parameters bound to third-party accounts)
        RETURN_URL: "returnUrl"
    },

    // 登录后用户信息存在本地
    loginLocalInfo: {
        USER_SUCCESS_ACCOUNT: '_lsa', // 老用户登录用户数据 account
    },

    LOGIN: {
        LOGIN_APPID: "80001", // 登录appid
        NEW_USER: "new", // 新用户
        PHONE_LOGIN: "phone", // 手机登录
        EMAIL_LOGIN: "email", // 邮箱登录
        USER_SUCCESS_ACCOUNT: "_lsa", // 老用户登录用户数据 account
        MIND_SESSION_STORAGE: "mind_storage", // 心智临时数据
        STEP_CODE: "_stepCode"
    },
    LoginTypeEnum: {
        MOBILE: 2, // 手机号登录(Mobile phone number login)
        EMAIL: 3, // 邮箱登录(Email Login)
        JD: 4,
        APPLE: 23, // Apple账号登录(Apple account login)
        FACEBOOK: 24, // Facebook账号登录(Facebook account login)
        GOOGLE: 25, // Google账号登录(Google account login)
        OCHAMA: 26
    },
    VerifyCodeSceneEnum: {
        LOGIN: 2, // 登录(Log in)
        BIND_MOBILE_OR_EMAIL: 3, // 绑定手机号(Bind mobile phone number)
        MODIFY_MOBILE_NEW: 5, // 修改手机号(新手机号发送验证码)(Modify mobile phone number (new mobile phone number will send verification code))
        RETRIEVE_PASSWORD: 7, // 找回密码(Retrieve password)
    },

    /*
        图形校验SDK
        Graphics Verification SDK
    */
    GoogleReCAPTCHAEnum: {
        KEY_ID: "6LeBC-QqAAAAAIVQrWJt0xkFHjwIwr8ZngUnXCuQ", // 秘钥ID
        UPDATE_PROFILE: "UPDATE_PROFILE",
    },
    // 登录发送验证码的时候 传入的参数 captchaAction 类型
    CaptchaActionEnum: {
        SIGNUP: "SIGNUP", // 登录
        FORGET_PASSWORD: "FORGET_PASSWORD", // 忘记密码
        SET_PHONE_EMAIL: "SET_PHONE_EMAIL", // 个人中心 修改手机号
    },

    MindScopeEnum: {
        HOME_PAGE: 1, // 主页
        SIGN_IN_REGISTER: 7, // 登录注册
    },
    // 风控场景
    RiskEnum:  {
        SCENE_BINDING: 21, // 用户输入手机或邮箱
        SCENE_AUTHENTICATION: 22, // 验证（验证用户已有的手机或邮箱）
        CODE_FREEZE: "15001", // 被冻结
        CODE_RISK: "15000", // 被风控
        CODE_FORBIDDEN_REGISTER: "15003", // 被风控
        CODE_ALREADY_SEND: "10024", // 重复发送验证码
        CODE_JOYBUY_RISK_MIN: 19000, // 滑块风控范围
        CODE_JOYBUY_RISK_MAX: 19099, // 滑块风控范围
        CODE_GOOGLE_RISK_MIN: 19100, // 谷歌风控范围
        CODE_GOOGLE_RISK_MAX: 19199, // 谷歌风控范围
        CODE_OCHAMA: "20000", // 三方联登
    },

    // 登录页面状态
    LoginStateEnum: {
        LOGIN_DEFAULT: "loginDefault",
        OLD_USER_LOGIN: "oldUserLogin",
        PHONE_LOGIN: "phoneLogin",

        EMAIL_REGISTER_PWD: "EmailRegisterPwd",
        EMAIL_REGISTER_CODE: "emailRegisterCode",

        EMAIL_LOGIN_PWD: "EmailLoginPwd",
        FORGET_PASSWORD: "ForgetPassword",
        CREATE_NEW_PASSWORD: "createNewPassword",
        SUCCESS_DOM: "successDom"
    },
}

